/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api; bearer: string };
type HookTuple = [vp.BillingSettingBasics[], (accountId: string) => void];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchAccountBillingSettings: ApiHook = ({ api, bearer }) => {
  const source = axios.CancelToken.source();

  const [accountBillingSettings, setAccountBillingSettings] = useState<{
    [idx: string]: vp.BillingSettingBasics;
  } | null>(null);

  const [accountId, setAccountId] = useState('');

  useEffect(() => {
    const loadData = async () => {
      const { BillingSettings } = await api.fetchAccountBillingSettings({ VopayAccountID: accountId }, bearer, source);

      if (BillingSettings) {
        setAccountBillingSettings(BillingSettings);
      }
    };

    if (accountId) void loadData();

    return () => {
      source.cancel();
    };
  }, [accountId]);

  return [
    Object.values(accountBillingSettings || {}),
    (_accountId: string) => {
      setAccountId(_accountId);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchAccountBillingSettings);
